import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Box, Rows } from '@/components/layout'
import { Link } from '@/components/common'

import styles from './BlogArticleListingSmall.module.scss'

const BlogArticleListingSmall = ({ title, link, img, imgAlt, date }) => (
  <Box className={styles.wrapper} gap={12}>
    <Link className={styles.imgLink} to={link}>
      <Image alt={imgAlt} className={styles.img} height={52} src={img} width={52} />
    </Link>
    <Rows className={styles.content} gap={0}>
      <Link className={styles.name} to={link}>{title}</Link>
      <p className={styles.details}>{date}</p>
    </Rows>
  </Box>
)

BlogArticleListingSmall.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  date: PropTypes.string,
}

export default BlogArticleListingSmall
